export default __webpack_public_path__ + "static/dodge-3d5c008ab9eb2fa4ee00d97f0958a3c0.gif";